<div class="cd-page">
  <app-counselor-nav></app-counselor-nav>

  <main class="cd-main" aria-label="User Management">
    <div>
      <h1 class="cd-title">User Management</h1>
      <p class="cd-subtitle">View users in your school and manage their role assignments</p>
    </div>

    <!-- Filters -->
    <div class="um-filters">
      <input
        type="text"
        class="um-search"
        placeholder="Search by name or email..."
        [(ngModel)]="searchTerm"
        aria-label="Search users"
        data-testid="user-search-input"
      />

      <select
        class="um-role-filter"
        [(ngModel)]="roleFilter"
        aria-label="Filter by role"
        data-testid="role-filter-select"
      >
        <option value="">All Roles</option>
        @for (role of roles; track role.id) {
          <option [value]="role.id">{{ role.name }}</option>
        }
      </select>
      <div class="um-action-group">
        <button
          type="button"
          class="um-btn um-btn-manage-roles"
          (click)="addUser()"
          aria-label="Add User"
          data-testid="add-user-btn"
          *hasPermission="permissions.USERS.INVITE"
        >
          Add User
        </button>

        <button
          type="button"
          class="um-btn um-btn-manage-roles"
          (click)="manageRoles()"
          aria-label="Manage roles"
          data-testid="manage-roles-btn"
        >
          Manage Roles
        </button>
      </div>
    </div>

    @if (loading) {
      <p class="um-loading">Loading users...</p>
    }

    @if (!loading && filteredUsers.length === 0) {
      <p class="um-empty">No users found</p>
    }

    @if (!loading && filteredUsers.length > 0) {
      <div class="um-table-wrapper">
        <table class="um-table" aria-label="School users">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Type</th>
              <th>Status</th>
              <th>Roles</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (user of filteredUsers; track user.id) {
              <tr>
                <td class="um-cell-name">{{ getDisplayName(user) }}</td>
                <td class="um-cell-email">{{ user.email }}</td>
                <td>
                  <span class="um-badge um-badge-type">{{ user.user_type }}</span>
                </td>
                <td>
                  <span
                    class="um-badge"
                    [class.um-badge-active]="user.is_active"
                    [class.um-badge-inactive]="!user.is_active"
                  >
                    {{ user.is_active ? 'Active' : 'Inactive' }}
                  </span>
                </td>
                <td class="um-cell-roles">
                  <div class="um-roles-inner">
                    @if (user.Roles.length === 0) {
                      <span class="um-no-roles">None</span>
                    }
                    @for (role of user.Roles; track role.id) {
                      <span class="um-role-chip">{{ role.name }}</span>
                    }
                  </div>
                </td>
                <td class="um-cell-actions">
                  <button
                    class="um-btn um-btn-manage"
                    (click)="manageUser(user.id)"
                    [attr.aria-label]="'Manage user ' + getDisplayName(user)"
                    [attr.data-testid]="'manage-user-btn-' + user.id"
                  >
                    Manage User
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <p class="um-count">Showing {{ filteredUsers.length }} of {{ users.length }} users</p>
    }
  </main>
</div>
